import { StyleSheet } from 'react-native';

import { heightPercentageToDP, isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        alignSelf: isTabletOrWeb ? 'flex-start' : 'center',
        marginBottom: heightPercentageToDP(8),
    },
});

export default styles;
